import MicroModal from 'micromodal'

/**
 * Footer legal modals (disclaimer / T&C / privacy), opened via
 * [data-micromodal-trigger]. awaitCloseAnimation lets the CSS slide-out
 * play before the modal is hidden; modals carry data-lenis-prevent so
 * their inner scroll isn't swallowed by Lenis.
 */
export function initLegalModals() {
  MicroModal.init({
    openClass: 'is-open',
    disableScroll: true,
    awaitCloseAnimation: true,
    onShow: (modal) => {
      // MicroModal focuses the first non-close focusable node on open;
      // in text-heavy modals that's a link partway down the content,
      // which scrolls the container away from the top. Keep focus in the
      // dialog (the close button) without scrolling, then pin to top.
      modal.querySelector('button[data-micromodal-close]')?.focus({ preventScroll: true })
      const content = modal.querySelector('.modal__content')
      if (content) content.scrollTop = 0
    },
  })
}
